export const formatTimestamp = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes.toString().padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
};

export const convertTimeToSeconds = (timeString: string): number => {
  const [minutes, seconds] = timeString.split(":").map(Number);
  return (minutes || 0) * 60 + (seconds || 0);
};

export const convertSecondsToTime = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes.toString().padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
};

export const validateTimeFormat = (value: string): boolean => {
  if (!value) return true;
  if (value.match(/^\d{1,2}$/)) return true;
  if (value.match(/^\d{1,2}:$/)) return true;
  if (value.match(/^\d{1,2}:\d{0,2}$/)) return true;
  return /^\d{1,2}:[0-5][0-9]$/.test(value);
};

export const formatTimeInput = (value: string): string => {
  value = value.replace(/[^\d:]/g, "");
  if (value.endsWith(":")) {
    return value.slice(0, -1);
  }
  if (value.length >= 2 && !value.includes(":")) {
    return `${value.slice(0, 2)}:${value.slice(2)}`;
  }
  return value;
};
